var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './CountTag.scss';
import classNames from 'classnames';
import { isNumber } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { Tooltip } from 'antd';
import { When } from 'react-if';
function getCountTagBase(className, color, count, icon, rest) {
    const style = {
        borderColor: color,
        color
    };
    return (React.createElement("div", Object.assign({ className: classNames('count-tag', className), style: style }, rest),
        icon,
        React.createElement(When, { condition: isNumber(count) },
            React.createElement("span", { className: 'count' }, count))));
}
export const CountTag = (_a) => {
    var { className, color, count, icon, tooltip, tooltipPlacement = 'bottomLeft', visible } = _a, rest = __rest(_a, ["className", "color", "count", "icon", "tooltip", "tooltipPlacement", "visible"]);
    if (visible === false) {
        return null;
    }
    const tagBase = getCountTagBase(className, color, count, icon, rest);
    if (!tooltip) {
        return tagBase;
    }
    return (React.createElement(Tooltip, { placement: tooltipPlacement, title: tooltip }, tagBase));
};
